<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>If you are located in the European Economic Area (EEA), we process your email address in accordance with the General Data Protection Regulation (GDPR).</p>
    <p>Lawful Basis for Processing:</p>
    <ul class="list-disc list-inside">
      <li>Consent: You voluntarily provide your email when signing up.</li>
      <li>Contractual necessity: We need your email to create and maintain your account and provide secure access.</li>
    </ul>
    <p>Your Rights under GDPR:</p>
    <ul class="list-disc list-inside">
      <li>Request access to the personal data we hold about you.</li>
      <li>Request correction or deletion of your data.</li>
      <li>Withdraw consent at any time (e.g., by deleting your account).</li>
    </ul>
    <p>To exercise these rights, contact us at <a href="mailto:gdpr@betpic.com" class="text-blue-600 dark:text-blue-400 underline">gdpr@betpic.com</a>. We will respond within the legal timeframe.</p>
  </div>
</template>